export enum EDecalVersion {
  VERSION_2 = 'version2',
  VERSION_3 = 'version3',
}

export const DEFAULT_DECAL_VERSION = EDecalVersion.VERSION_2;
